export const SCHEMA_KEYWORDS = {
    PROPERTIES: 'properties',
    REQUIRED: 'required',
    CONST: 'const',
    IF: 'if',
    BOOLEAN: 'boolean',
    NUMBER: 'number',
    INTEGER: 'integer',
    ARRAY: 'array',
    OBJECT: 'object',
    STRING: 'string',
    MULTIPLE_ENUM: 'multipleEnum',
    ENUM: 'enum',
    FILE: 'file',
    BUTTON: 'button',
    REMOVE_BUTTON: 'removeButton',
    ADD_BUTTON: 'addButton'
}
